module.exports = __webpack_public_path__ + "img/metaldd.120215b9.jpg";